import {get} from 'api/get';
import {post} from 'api/post';
import {put} from 'api/put';
import { reqDelete } from 'api/req-delete';
import {buildErrorPayload} from 'state/buildErrorPayload';
import {appendStatus} from 'state/status/actions';

import _ from 'lodash';

export const GS_GET_VARIETALS_SUCCESS = 'gs/get/varietals/success';
export const GS_GET_VARIETALS_FAILURE = 'gs/get/varietals/failure';

export const GS_GET_NEXTERNAL_VARIETALS_SUCCESS = 'gs/get/nexternal-varietals/success';
export const GS_GET_NEXTERNAL_VARIETALS_FAILURE = 'gs/get/nexternal-varietals/failure';

export const GS_GET_VARIETALS_DETAILS_REQUEST = 'gs/get/varietals/details/request';
export const GS_GET_VARIETALS_DETAILS_SUCCESS = 'gs/get/varietals/details/success';
export const GS_GET_VARIETALS_DETAILS_FAILURE = 'gs/get/varietals/details/failure';

export const GS_TOGGLE_VARIETALS_DETAILS_MODAL = 'gs/varietals/toggle-details-modal';
export const GS_TOGGLE_VARIETALS_ADDNEW_MODAL = 'gs/varietals/toggle-add-new-modal';

export const GS_SAVE_VARIETALS_DETAILS_SUCCESS = 'gs/save/varietals/details/success';
export const GS_SAVE_VARIETALS_DETAILS_FAILURE = 'gs/save/varietals/details/failure';

export const GS_ADD_NEW_VARIETAL_SUCCESS = 'gs/add/varietal/success';
export const GS_ADD_NEW_VARIETAL_FAILURE = 'gs/add/varietal/failure';

export const GS_SEARCH_LIST = 'gs/search-list';

export const GS_DELETE_VARIETAL_SUCCESS = 'gs/delete/varietal/success';
export const GS_DELETE_VARIETAL_FAILURE = 'gs/delete/varietal/failure';

export const GS_VARIETALS_GROUP_BY = 'gs/varietals/group-by';

export function getVarietalsAll() {
  return async (dispatch, getState) => {

    try {

      let groupBy = getState().globalSettingsVarietals.groupById;
      const requestOptions = {
        groupby: groupBy
      };
      
      const req = await get('global-settings/varietals', requestOptions);
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GS_GET_VARIETALS_SUCCESS,
        payload: data
      });
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GS_GET_VARIETALS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function getNexternalVarietals() {
  return async dispatch => {

    try {
      const req = await get('global-settings/nexternal-varietals');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GS_GET_NEXTERNAL_VARIETALS_SUCCESS,
        payload: data
      });
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GS_GET_NEXTERNAL_VARIETALS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function getVarietalDetails(id) {
  return async (dispatch) => {

    try {
      dispatch({
        type: GS_GET_VARIETALS_DETAILS_REQUEST,
        payload: null
      });

      const req = await get('global-settings/varietals/' + id);
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GS_GET_VARIETALS_DETAILS_SUCCESS,
        payload: data
      });
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GS_GET_VARIETALS_DETAILS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function toggleDetailsModal(show) {
  return {
    type: GS_TOGGLE_VARIETALS_DETAILS_MODAL,
    payload: {
      show: show
    }
  }
}

export function saveDetails(data) {
  return async (dispatch) => {

    try {
      await put('global-settings/varietals', data);

      dispatch({
        type: GS_SAVE_VARIETALS_DETAILS_SUCCESS,
        payload: null
      });

      dispatch(toggleDetailsModal(false));
      dispatch(getVarietalsAll());

      dispatch(appendStatus('Varietal Composition details saved successfully.', 'info'));
    }
    catch (error) {

      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GS_SAVE_VARIETALS_DETAILS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function toggleAddNewModal(show) {
  return {
    type: GS_TOGGLE_VARIETALS_ADDNEW_MODAL,
    payload: {
      show: show
    }
  }
}

export function addNew(data) {
  return async (dispatch) => {

    try {
      await post('global-settings/varietals', data);

      dispatch({
        type: GS_ADD_NEW_VARIETAL_SUCCESS,
        payload: null
      });

      dispatch(toggleAddNewModal(false));
      dispatch(getVarietalsAll());

      dispatch(appendStatus('Varietal Composition saved successfully.', 'info'));
    }
    catch (error) {

      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GS_ADD_NEW_VARIETAL_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function searchList( q ) {
  return {
    type: GS_SEARCH_LIST,
    payload: q
  }
}

export function deleteVarietal( varietalId ) {

  return async (dispatch) => {

    let dataToSend = {
      id: varietalId,
    }

    try {
      await reqDelete('global-settings/varietals', dataToSend);

      dispatch({
        type: GS_DELETE_VARIETAL_SUCCESS,
        payload: null
      });

      dispatch(getVarietalsAll());
      dispatch(appendStatus('Varietal Composition deleted successfully.', 'info'));
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GS_DELETE_VARIETAL_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function groupBy(groupById) {

  return async (dispatch) => {
    dispatch({
      type: GS_VARIETALS_GROUP_BY,
      payload: {
        groupBy: groupById
      }
    });

    dispatch(getVarietalsAll());
  }
}